import { createAsyncThunk } from "@reduxjs/toolkit";
import $axios from "src/utils/axios";
import { clearAuth } from "./authSlice";
import { setFeatures } from "../ui/uiSlice";

export const fetchUserDetails = createAsyncThunk(
  "auth/fetchPermission",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const { token } = getState().auth;
    if (!token) {
      dispatch(clearAuth());
      return rejectWithValue("No token found");
    }

    try {
      const response = await $axios.get('account/me');
      const { permissions, role, features } = response?.data?.response;
      dispatch(setFeatures(features));
      return { accessPermissions: permissions, role }
    }
    catch (err) {
      dispatch(clearAuth());
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch user details"
      );
    }
  }
)
